import { z } from 'zod';
import { AdminActionInput, AdminRole } from '../shared.js';
import { GrantablePermission } from '../rbac.js';
// ── custom admin roles (NipigeV3 pattern: roles are named permission sets) ──
/**
 * A custom role stores nothing but a name and a subset of the code-defined
 * permission registry. `GrantablePermission` (not the full registry) is the
 * write schema, so the two reserved platform permissions are unrepresentable
 * in a role document — a custom role cannot be authored into the power to
 * manage admins or roles.
 */
export const CustomRoleInput = AdminActionInput.extend({
    name: z.string().trim().min(3).max(40),
    permissions: z.array(GrantablePermission).min(1),
});
export const CustomRoleView = z.object({
    id: z.string(),
    name: z.string(),
    permissions: z.array(GrantablePermission),
    /** How many admin accounts currently hold this role — deletion is refused while > 0. */
    assignedCount: z.number().int().min(0),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
/**
 * Reassign an admin's role: exactly one of a built-in role or a custom role
 * id. Kept as one endpoint because it is one act — "this person's powers are
 * now X" — whichever family X comes from.
 */
export const SetAdminRoleInput = AdminActionInput.extend({
    role: AdminRole.optional(),
    customRoleId: z.string().optional(),
}).refine((v) => (v.role === undefined) !== (v.customRoleId === undefined), {
    message: 'Provide exactly one of role or customRoleId',
});
//# sourceMappingURL=schemas.js.map